import React from 'react'

interface Props {
  children: any
}

function AssetDeliveryContainer({ children }: Props) {
  return (
    <div className="asset-delivery-container">
      {children}
    </div>
  )
}

export default AssetDeliveryContainer
